import * as React from "react";
import CreateService from "../../service/create";
import PopDetail from "../popdetail";
import ReadService from "../../service/read";
import Wait from "../wait";
import GeneralSelect from "../general_select";
export default class AddDeedPlanSpatialPane extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            srid:0,
            deedplanOptions: {endpoint: `spatial/deedplan/info/${this.props.project.id}`, value: 'id', label: 'name', placeholder: 'Select Deed Plan'},
        }


        this.loadData = this.loadData.bind(this)
        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect =this.generalSelect.bind(this)
    }

    handleChanges=(e)=>{this.setState({[e.target.name]:e.target.value})}
    handleChangeFile=e=>{this.setState({ zipped:e.target.files[0] })}

     generalSelect(data,name) {
        //console.log(data)
         this.setState({
             [name]: data.value
         })


     }

    render() {
        return(<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding:0}}>

                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2,display:'none'}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Project Initiation
                    </span>

                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

                <table style={{width:'94%',margin:'2%'}}>
                    <tbody>

                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Select Deed Plan Info</td>
                    </tr>
                    <tr>
                        <td>
                             <GeneralSelect  onChanges={(e)=>this.generalSelect(e,'deedplan')} parameters={this.state.deedplanOptions} />
                         </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Layer Type</td>
                    </tr>
                    <tr>
                        <td>
                            <select style={{width:'100%'}} onChange={this.handleChanges} name={'layer'}>
                                <option value={''}>- Choose One -</option>
                                <option value={'beacons'}>Beacons</option>
                                <option value={'plots'}>Surveyed Plots ( Polygons )</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Shapefile Description - Column Name</td>
                    </tr>
                    <tr>
                        <td>
                            <input type={'text'} style={{width:'100%'}} name={'name'} onChange={this.handleChanges}/>
                        </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Projection ( SRID )</td>
                    </tr>
                    <tr>
                        <td>
                             <select defaultValue={this.state.srid} style={{width:'100%'}} onChange={this.handleChanges} name={'srid'}>
                                <option value={0}>- Choose One -</option>
                                 <option>32737</option>
                                 <option>32736</option>
                                 <option>4326</option>
                            </select>
                        </td>
                    </tr>

                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Shapefile</td>
                    </tr>
                    <tr>
                         <td>
                             <input type={'file'} accept=".zip,.ZIP" name={'zipped'} onChange={this.handleChangeFile}/>
                         </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{textAlign:'center',width:'100%',float:'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Save
                    </button>
                     <button className={'btn error'} onClick={()=>PopDetail.dismiss()}>
                        <span className={'fa fa-times'}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }

    loadData(){

        try{
            Wait.show('Fetching Villages....')
            ReadService.fetchProjectVillages(this.props.project.id).then(r => {
                Wait.dismiss()
                this.setState({
                    villages:r.data.results
                })
            })
        }catch (e) {
            console.log(e)
        }

        //console.log('here,...')
        //console.log(this.props.project)
    }


    submit(){
        try{

            let layer = this.state.layer
            let srid = this.state.srid
            let name = this.state.name
            let deedplan = this.state.deedplan

            if (deedplan===undefined){
                alert('No Deed Plan Info')
                return
            }

            const formData = new FormData()
            formData.append('zipped',this.state.zipped)
            formData.append('extra',JSON.stringify({
                layer:layer,
                srid:srid,
                name:name,
                deedplanId:deedplan
            }))

            Wait.show('Creating Layer...')
            CreateService.createLayer(formData).then(d=>{
                Wait.dismiss()
                if (d.data.status===0){
                    alert(d.data.message)
                    return
                }
                this.props.loadData()
                PopDetail.dismiss()
            })




        }catch (e) {
             alert(e)
        }
    }


}